export default __webpack_public_path__ + "static/media/mobileresearch.125b6f1c.svg";